import type { SVGProps } from 'react';
const SvgBreakfastDining = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="0.75em"
    height="0.75em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#breakfast_dining_svg__a)">
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M18 3H6C3.79 3 2 4.79 2 7c0 1.48.81 2.75 2 3.45V19c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2v-8.55c1.19-.69 2-1.97 2-3.45 0-2.21-1.79-4-4-4Zm-4 12h-4v-4h4v4Z"
        clipRule="evenodd"
      />
    </g>
    <defs>
      <clipPath id="breakfast_dining_svg__a">
        <path fill="currentColor" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgBreakfastDining;
